import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import MascotAccent from "@/components/feature/MascotAccent";
import { REFORM_MAIN_IMAGE } from "@/constants";

const oneStopFlow = [
  { icon: "ri-truck-line", label: "不用品回収・遺品整理" },
  { icon: "ri-box-3-line", label: "片付け・搬出" },
  { icon: "ri-home-gear-line", label: "原状回復" },
  { icon: "ri-hammer-line", label: "住宅リフォーム" },
];

export default function OneStop() {
  return (
    <section id="onestop" className="relative overflow-hidden bg-background-100 py-16 md:py-24">
      <MascotAccent variant="work" className="left-5 top-8 hidden h-16 w-16 xl:block" />
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="ONE-STOP"
            under="片付けは片付け業者、内装は内装業者、屋根や外壁はリフォーム会社…と分けずに、窓口ひとつでご相談いただけます。"
          >
            片付けから、その先のリフォームまで。
          </SectionTitle>
        </Reveal>

        {/* メインビジュアル：送っていただいた横長画像を加工せず、セクション幅いっぱいに表示 */}
        <Reveal delay={80}>
          <div className="mt-10">
            <img
              src={REFORM_MAIN_IMAGE.src}
              alt={REFORM_MAIN_IMAGE.alt}
              className="block h-auto w-full"
            />
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mx-auto mt-10 max-w-3xl rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <p className="text-base font-bold text-primary-700">一社でまとめて対応できる流れ</p>
            <ol className="mt-4 space-y-3">
              {oneStopFlow.map((step, i) => (
                <li key={step.label} className="flex items-center gap-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100">
                    <i className={`${step.icon} text-xl text-primary-700`} />
                  </span>
                  <span className="font-heading text-lg font-black text-foreground-900">{step.label}</span>
                  {i < oneStopFlow.length - 1 ? (
                    <i className="ri-arrow-down-line ml-auto text-lg text-primary-400" />
                  ) : (
                    <i className="ri-checkbox-circle-fill ml-auto text-lg text-primary-500" />
                  )}
                </li>
              ))}
            </ol>

            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              <div className="rounded-lg border border-background-300 bg-background-50 p-4">
                <p className="text-xs font-bold text-foreground-500">一般的な場合</p>
                <p className="mt-1 font-heading text-base font-black text-foreground-700">
                  片付け・内装・リフォームで
                  <br />
                  別々に業者を探す
                </p>
                <ul className="mt-2 space-y-1.5 text-sm text-foreground-500">
                  <li className="flex items-center gap-1.5">
                    <i className="ri-close-circle-line text-foreground-400" />
                    複数の業者へ個別に依頼
                  </li>
                  <li className="flex items-center gap-1.5">
                    <i className="ri-close-circle-line text-foreground-400" />
                    打ち合わせが何度も必要
                  </li>
                </ul>
              </div>
              <div className="rounded-lg border-2 border-primary-400 bg-primary-50 p-4">
                <p className="text-xs font-bold text-primary-700">小林建設の場合</p>
                <p className="mt-1 font-heading text-base font-black text-primary-900">
                  窓口ひとつで
                  <br />
                  まとめて相談
                </p>
                <ul className="mt-2 space-y-1.5 text-sm text-primary-800">
                  <li className="flex items-center gap-1.5">
                    <i className="ri-checkbox-circle-fill text-primary-600" />
                    業者を探す手間が少ない
                  </li>
                  <li className="flex items-center gap-1.5">
                    <i className="ri-checkbox-circle-fill text-primary-600" />
                    打ち合わせをまとめられる
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}